import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-text-dialog',
  templateUrl: './text-dialog.component.html',
  styleUrls: ['./text-dialog.component.scss']
})
export class TextDialogComponent  extends DialogContentBase implements OnInit {

  constructor( public dialog: DialogRef,
    private fb:UntypedFormBuilder) {   super(dialog);  }

  @Input() label:string;
  @Input() selectedText:string;
  @Input() useTextArea:boolean;
  form: UntypedFormGroup;

  ngOnInit(): void {
    this.form = this.getForm();
  }

  confirm(){
    const result = this.form.controls['selectedText'].value;
        this.dialog.close({ text: 'OK' , selectedText: result});
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  getForm( ) {
    return this.fb.group({
      selectedText: [this.selectedText, Validators.required],
    });
  }
}
